import { render, staticRenderFns } from "./passwordRestConfirmation.vue?vue&type=template&id=7a1aeedf"
import script from "./passwordRestConfirmation.vue?vue&type=script&lang=js"
export * from "./passwordRestConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports